var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationGradientIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 221.50599 297.00101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Gradiente_sem_nome_35);}.cls-2{fill:url(#Gradiente_sem_nome_35-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_35",
    x1: 23.8386,
    y1: 41.12489,
    x2: 197.66769,
    y2: 214.95398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17806,
    stopColor: "#00fc6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34146,
    stopColor: "#00f479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4991,
    stopColor: "#00e58b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65324,
    stopColor: "#00d1a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80485,
    stopColor: "#00b7c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95254,
    stopColor: "#0097f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_35-2",
    x1: 73.93077,
    y1: 74.28328,
    x2: 146.92559,
    y2: 147.2781,
    xlinkHref: "#Gradiente_sem_nome_35"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.753,0A110.89987,110.89987,0,0,0,0,110.797c0,91.026,99.729,179.905,103.976,183.645a10.25462,10.25462,0,0,0,13.555,0c4.245-3.739,103.975-92.618,103.975-183.645A110.89985,110.89985,0,0,0,110.753,0Zm0,272.689C88.704,251.323,20.51,179.66,20.51,110.797a90.243,90.243,0,1,1,180.486,0C200.996,179.659,132.802,251.322,110.753,272.689Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M110.753,59.183a51.61513,51.61513,0,1,0,51.27287,51.95513q.00113-.17056.00113-.34113A51.50288,51.50288,0,0,0,110.753,59.183Zm0,82.718a31.10587,31.10587,0,1,1,30.76314-31.44487q.00185.17043.00186.34087A30.97073,30.97073,0,0,1,110.753,141.901Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationGradientIc);
export default __webpack_public_path__ + "static/media/location-gradient-ic.1d75e930a3408db81ea1f714111a208a.svg";
export { ForwardRef as ReactComponent };